export const baseUrl = 'https://qweerp-backend-77d83d0d698d.herokuapp.com'

export const postRegisterUser = `${baseUrl}/api/register`

export const postLogin = `${baseUrl}/api/login`